import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { useGetBanner } from "@vega-api/generated/banner/banner";
import { useSessionStorage } from "@vega-core/hooks/useSessionStorage";

import { ConfigBanner } from "./ConfigBanner";

const DISMISSED_BANNERS_STORAGE_KEY = "configBannerDismissedIds";

export const AuthenticatedConfigBanner = () => {
  const { featureFlag } = useFeatureFlag();
  const flagOn = Boolean(featureFlag[FeatureFlag.LP_AUTH_LOGIN_TASK]);
  const { data } = useGetBanner({ query: { enabled: flagOn, retry: false } });
  const [dismissedIds, setDismissedIds] = useSessionStorage<string[]>(
    DISMISSED_BANNERS_STORAGE_KEY,
    [],
  );

  if (!flagOn) {
    return null;
  }

  return (
    <ConfigBanner
      banner={data?.data ?? null}
      dismissedIds={dismissedIds}
      onDismiss={(bannerId) =>
        setDismissedIds((previous) => [...previous, bannerId])
      }
      sticky={false}
    />
  );
};
